module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-4-73aeaa105009484d9a2c21e3b9c35a3a.svg";